export default __webpack_public_path__ + "static/media/231.ae3f599a.jpg";